import { makeStyles } from "@mui/styles";
import { SwipeableList, SwipeableListItem } from "@sandstreamdev/react-swipeable-list";
import { Draggable, Droppable } from "react-beautiful-dnd";

import TagItem from "./TagItem";
import { EyeClosed, EyeNormal } from "../../../../icons";
import { DraggableStyles } from "../../../containers/DraggableStyles";
import SwipeWrapper from "../../../containers/SwipeWrapper";

const useStyles = makeStyles({
  sortTableTagList: {
    "& li": {
      display: "flex",
      "flex-direction": "row",
      alignItems: "center",
      border: 2,
      borderColor: "#FFF",
      padding: "0 15px 0 15px",
      "& svg": {
        marginRight: "0.5rem",
        color: "#FFF",
        "& path": { stroke: "#FFF" },
      },
      "& form": {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      },
    },
  },
  eyeIcons: {
    fontSize: "1.6rem",
    marginRight: "calc(.5rem + 3px)",
  },
});

export default function SortedTagList(props) {
  const {
    filteredTags,
    filteredTagMediaItems,
    tabStatus,
    onTagNameChangeComplete,
    onChangeTagStatus,
    startDrag,
    indexId,
    onChangeContentSortOrder,
    locked,
  } = props;

  const classes = useStyles();

  const Wrapper = ({ children, condition, wrapper }) => (condition ? wrapper(children) : children);

  const TagItemComponent = ({ tag, index, snapshotDraggable = "", providedDraggable }) => {
    return (
      <TagItem
        providedDraggable={providedDraggable}
        indexId={indexId}
        index={index}
        snapshotDraggable={snapshotDraggable}
        tag={tag}
        filteredTagMediaItems={filteredTagMediaItems}
        tabStatus={tabStatus}
        startDrag={startDrag}
        onTagNameChangeComplete={onTagNameChangeComplete}
        onChangeTagStatus={onChangeTagStatus}
        onChangeContentSortOrder={onChangeContentSortOrder}
        locked={locked}
      />
    );
  };

  return (
    <>
      <Droppable droppableId="droppableTagList" isDropDisabled={tabStatus !== "customize" || locked}>
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef} className={classes.sortTableTagList}>
            {filteredTags.map((tag, index) => (
              <div key={`${tag.id}`}>
                {!tag.hidden && (
                  <Draggable
                    draggableId={`tag-list-${tag.id}`}
                    index={index}
                    isDragDisabled={tag.hidden || tabStatus !== "customize"}
                    disableInteractiveElementBlocking={false}
                  >
                    {(providedDraggable, snapshotDraggable) => {
                      const currentlyDragged =
                        providedDraggable &&
                        providedDraggable.dragHandleProps &&
                        providedDraggable.dragHandleProps["data-rbd-drag-handle-draggable-id"];

                      const getStyleResults = DraggableStyles(providedDraggable.draggableProps, tag.hidden, () =>
                        onChangeTagStatus(tag, index),
                      );

                      const isCurrentlyDragged =
                        snapshotDraggable.isDragging && currentlyDragged === `tag-list-${tag.id}`;

                      return (
                        <Wrapper
                          condition={tabStatus === "customize"}
                          wrapper={(children) => (
                            <SwipeWrapper
                              icon={
                                tag.hidden ? (
                                  <EyeNormal className={classes.eyeIcons} />
                                ) : (
                                  <EyeClosed className={classes.eyeIcons} />
                                )
                              }
                              opacity={getStyleResults.swipeOpacity}
                              zIndex={isCurrentlyDragged ? "2" : "0"}
                            >
                              {children}
                            </SwipeWrapper>
                          )}
                        >
                          <div
                            className={classes.tagContainer}
                            ref={providedDraggable.innerRef}
                            {...providedDraggable.draggableProps}
                            style={{
                              ...getStyleResults,
                              zIndex: isCurrentlyDragged ? "3" : "1",
                            }}
                          >
                            <TagItemComponent
                              providedDraggable={providedDraggable}
                              snapshotDraggable={snapshotDraggable}
                              index={index}
                              tag={tag}
                            />
                          </div>
                        </Wrapper>
                      );
                    }}
                  </Draggable>
                )}
              </div>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
      {tabStatus === "customize" && (
        <div className={classes.sortTableTagList} style={{ width: "240px" }}>
          {filteredTags.map((tag, index) => (
            <div key={`hidden-tag-list-${tag.id}`}>
              {tag.hidden && (
                <SwipeableList>
                  <SwipeableListItem
                    swipeLeft={{
                      content: tag.hidden ? (
                        <EyeNormal className={classes.eyeIcons} />
                      ) : (
                        <EyeClosed className={classes.eyeIcons} />
                      ),
                      action: () => {
                        onChangeTagStatus(tag, index);
                      },
                    }}
                  >
                    <TagItemComponent index={index} tag={tag} />
                  </SwipeableListItem>
                </SwipeableList>
              )}
            </div>
          ))}
        </div>
      )}
    </>
  );
}
